<template>
  <div id="crewPage" class="mt-3">
    <crew-list detailed="false" />
  </div>
</template>

<script>
import CrewList from '../components/CrewList.vue';

export default {
  name: 'Crew',
  components: {CrewList}
};
</script>

<style scoped>

</style>
